//const { environment } = require("./environments/environment");

var event;
var ids = "";
var source = "";
var deviceId="";
var token="";
var timeCnt=0;
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////                    PUSH DATA FUNCTIONs                      //////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
function getDeviceId()
{
    if(deviceId=="")
    {
        if (typeof app !== "undefined" && app !== null) {
            deviceId=app.readDeviceId();
            console.log("Got Data-Device ID : "+deviceId)
            localStorage.setItem("DeviceId",deviceId)
            document.getElementById("deviceId").innerHTML=deviceId
        }
    }
}
function getFCMToken()
{
    if(token==""){
        if (typeof app !== "undefined" && app !== null) {
            token=app.readToken();
            console.log("Got Data- Token : "+token)
            localStorage.setItem("FirebaseToken", token);
            var firebaseToken = new CustomEvent("FirebaseToken", {
                detail: { token: token },
            });
            window.dispatchEvent(firebaseToken);
        }
    }
}
function getLongLat()
{
    console.log("Got Data-Called ")
    if (typeof app !== "undefined" && app !== null) {
        var longLat=app.readLongLat();
        console.log("Got Data-Long Lat : "+longLat)
        localStorage.setItem("lat", longLat.split("===")[0]);
        localStorage.setItem("long", longLat.split("===")[1]);
        var latlongFire = new CustomEvent("LongLatRec", {
            detail: { lat: longLat.split("===")[0], long: longLat.split("===")[1] },
        });
        window.dispatchEvent(latlongFire);
    }
}

function sendSSERequest()
{
    console.log("Trying To Connect To SSE : "+deviceId)
    if(deviceId!="")
    {
        if(location.href.includes("login") || location.href.includes("http://localhost:4300"))
            return;
          var source = new EventSource(
            "https://1bakeshop.integration.mobitrix.net/enableSSEForTheDigitalDevice/" +
            deviceId,
            {
              mode: "no-cors",
              header: {
                "Access-Control-Allow-Origin": "*",
              }
            }
          );
        source.addEventListener(
            "message",
            function(e) {
                console.log("SSE PART : "+e.data);
                getSSEResponse(e.data);
            },
            false
        );
    }
}
function getSSEResponse(data) {
    var selectionFired = new CustomEvent("SSEMessage", {
        detail: { resp: data },
    });
    //sendSSERequest();
    //window.dispatchEvent(selectionFired);
}
function pullTheData()
{
    console.log("OS Type: ",getOSName())
    if(getOSName()=="Android")
    {
        getDeviceId();
       // getFCMToken();
        getLongLat();
    }
    if(timeCnt>5 || timeCnt==0)
    {
        //Run in every 10 Minutes
        //sendSSERequest();
        timeCnt=1;
    }
    timeCnt++;
}

setTimeout(pullTheData,5000);
setTimeout(pullTheData,15000);
setInterval(pullTheData,120000);


function StopMessageAndBeep() {
    if (typeof app !== "undefined" && app !== null) {
        console.log("StopMessageAndBeep")
        app.onNewOrderDialogCloseAnd();
    }
}

function onPrintSaleInvCumBOS(data) {
    if (typeof app !== "undefined" && app !== null) {
        app.onPrintSaleInvCumBOS(data);
    }
}

function shareFile(data, file) {
    if (typeof app !== "undefined" && app !== null) {
        app.shareFile(data, file);
    }
}

function downloadFile(data, file, extension) {
    if (typeof app !== "undefined" && app !== null) {
        app.downloadFile(data, file, extension);
    }
}

function sendToAndForDownload(data, file) {
    if (typeof app !== "undefined" && app !== null) {
        app.sendToAndForDownload(data, file);
    }
}

function onPrintOrder(data) {
    if (typeof app !== "undefined" && app !== null) {
        app.onPrintOrder(data);
    }
}

function OnPrintMakeToOrder(data) {
    if (typeof app !== "undefined" && app !== null) {
        app.onPrintMakeToOrder(data);
    }
}

function printToken(data, tokenNo) {
    if (typeof app !== "undefined" && app !== null) {
        app.printToken(data, tokenNo);
    }
}

function startScanner() {
    return app.startScanner();
}

function qrCodeData(elementId, sourcepage) {
    ids = elementId;
    source = sourcepage;
    app.onQRCodeClicked();
}

function setUserIdFromApp(userId) {
    if (typeof app !== "undefined" && app !== null) {
        console.log("USER ID=" + userId + "===============" + userId);
        app.setUserId(userId);
    }
}

function pushSSEData(sseData) {
    if (typeof app !== "undefined" && app !== null) {
        console.log("SSE Data=" + sseData + "===============" + sseData);
        app.receiveSSEData(sseData);
    }
}

function disableFileChhoserfunction(sourceType) {
    console.log("showHide ID=" + sourceType);
    if (typeof app !== "undefined" && app !== null) {
        console.log("showHide ID=" + sourceType);
        app.disableFileChhoserfunction(sourceType);
    }
}

function disableFileChhoserfunctionCamera(sourceType) {
    console.log("showHide ID=" + sourceType);
    if (typeof app !== "undefined" && app !== null) {
        console.log("showHide ID=" + sourceType);
        app.disableFileChhoserfunctionCamera(sourceType);
    }
}

function appUpdateForDevice(deviceId, refNo) {
    console.log("Sending T0 App:  deviceId=" + deviceId + " & Ref=" + refNo);
    if (typeof app !== "undefined" && app !== null) {
        app.appUpdateForDeviceMatched(deviceId, refNo);
    }
}

function onMapClicked(data) {
    if (typeof app !== "undefined" && app !== null) {
        app.onMapClicked(data);
    }
}

function textToSpeechAnd(data) {
    if (typeof app !== "undefined" && app !== null) {
        app.textToSpeechData(data);
    }
}

function logOutApp() {
    if (typeof app !== "undefined" && app !== null) {
        app.logOutClicked();
    }
}

function pushPullData(data)
{
    var rider = new CustomEvent("RiderNotification", {
        detail: { refNo: data.split("====")[0], message: data.split("====")[1], beep: data.split("====")[2], readMessage: data.split("====")[3] },
    });
    window.dispatchEvent(rider);
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////                    PULL DATA FUNCTIONs                      //////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
window.receiveAllData = function(data, pushType) {
    console.log(
        "Received Data Type=" +
        pushType +
        "  ==As==  " +
        data
    );

    if (pushType == "DeviceID") {
        console.log("Received Data Type=1 : "+data)
        localStorage.setItem("DeviceID", data);
        document.getElementById("deviceId").innerHTML=data
    }
    if (pushType === "RiderVerified") {
        var rider = new CustomEvent("RiderVerified", {
            detail: { verified: data },
        });
        window.dispatchEvent(rider);
    }
    if (pushType === "Rider Notification") {
        var rider = new CustomEvent("RiderNotification", {
            detail: { data: data },
        });
        window.dispatchEvent(rider);
    }
    if (pushType === "Cancel Message") {
        var rider = new CustomEvent("CancelMessage", {
            detail: { data: data },
        });
        window.dispatchEvent(rider);
    }




    if (pushType === "longlat" && data != null) {
        console.log(
            "Received Data Type Lat : =" +
            data.split("===")[0] +
            "  ==long==  " +
            data.split("===")[1]
        );
        localStorage.setItem("lat", data.split("===")[0]);
        localStorage.setItem("long", data.split("===")[1]);
        console.log(
            "Long Lat Set : lat " +
            localStorage.getItem("lat") +
            "  ==long==  " +
            localStorage.getItem("long")
        );
        var latlongFire = new CustomEvent("LongLatRec", {
            detail: { lat: data.split("===")[0], long: data.split("===")[1] },
        });
        window.dispatchEvent(latlongFire);
    }

    if (pushType == "FirebaseToken") {
        localStorage.setItem("FirebaseToken", data);

        var firebaseToken = new CustomEvent("FirebaseToken", {
            detail: { token: data },
        });
        window.dispatchEvent(firebaseToken);
    }
   
    if (pushType == "AppUpdated") {
        localStorage.setItem("appUdatedInDevice", data);
    }

    if (
        localStorage.getItem("DeviceID") != null &&
        localStorage.getItem("FirebaseToken") != null
    ) {
        event = new Event("ReceivedDeviceInfo");
        window.dispatchEvent(event);
    }
    if (pushType == "Notification") {
        event = new Event("ReceivedNotification");
        window.dispatchEvent(event);
    }
    
    if (pushType === "userDetails") {
        console.log("Received userDetails in JS====" + data.split("===").length)
        console.log("Received userDetails in JS====Last Data==" + data.split("===")[16])
        var rider = new CustomEvent("SSOUserDetailsPulled", {
            detail: {
                refNo: data.split("===")[0],
                firstName: data.split("===")[1],
                lastName: data.split("===")[2],
                mobileNo: data.split("===")[3],
                email: data.split("===")[4],
                dob: data.split("===")[5],
                education: data.split("===")[6],
                vehicleType: data.split("===")[7],
                vehicleNo: data.split("===")[8],
                vehicleName: data.split("===")[9],
                vehicleRegNo: data.split("===")[10],
                aadhaarNo: data.split("===")[11],
                riderSelfiePath: data.split("===")[12],
                fromLocationCode: data.split("===")[13],
                activeStatus: data.split("===")[14],
                isVerified: data.split("===")[15],
                aadhaarImagePath: data.split("===")[16]
            },
        });
        window.dispatchEvent(rider);

        // localStorage.setItem("lastName", data.split("===")[0]);
        // localStorage.setItem("id", data.split("===")[1]);
        // localStorage.setItem("firstName", data.split("===")[2]);
        // localStorage.setItem("lastName", data.split("===")[3]);
    }
};
window.pushedOrderData = function (title, body, data) {
    console.log("Received Order Data=" + title + "," + body + "," + data);
    var order = new CustomEvent("ReceivedPushedOrder", {
      detail: {
        title: title,
        body: body,
        data: data,
      },
    });
  
    window.dispatchEvent(order);
  };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////                Code To block multiple Tabs of the same website                  //////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
localStorage.openpages = Date.now();
var onLocalStorageEvent = function(e) {
    if (e.key == "openpages") {
        localStorage.page_available = Date.now();
    }
    if (e.key == "page_available") {
        event = new Event("tabOpened");
        window.dispatchEvent(event);
        //window.CloseEvent();
    }
};
window.addEventListener("storage", onLocalStorageEvent, false);

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////                                    Added For SSE                                //////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// function SSELoader() {
//     console.log(
//       "Loading on Device ID=" + document.getElementById("deviceId").innerHTML
//     );
//     if (
//         document.getElementById("deviceId").innerHTML == null
//     )
//         return;
//     var source = new EventSource(
//         "https://sse.mobitrix.net/enableSSEForTheDigitalDevice/" +
//         document.getElementById("deviceId").innerHTML, {
//             mode: "no-cors",
//             header: {
//                 "Access-Control-Allow-Origin": "*",
//             },
//         }
//     );
//     source.addEventListener(
//         "message",
//         function(e) {
//             console.log("SSE PART : "+e.data);
//             getSSEResponse(e.data);
//         },
//         false
//     );
// }


// setTimeout(SSELoader, 30000);
// setInterval(SSELoader, 900000);


module.exports = {
    textToSpeechAnd,
    onPrintSaleInvCumBOS,
    shareFile,
    downloadFile,
    sendToAndForDownload,
    onPrintOrder,
    OnPrintMakeToOrder,
    printToken,
    startScanner,
    qrCodeData,
    setUserIdFromApp,
    pushSSEData,
    disableFileChhoserfunction,
    appUpdateForDevice,
    onMapClicked,
    disableFileChhoserfunctionCamera,
    logOutApp,
    StopMessageAndBeep,
    pushPullData,
    PushUserIdAndLocToAndroidApp
};

const lazyRetry = function(componentImport) {
    return new Promise((resolve, reject) => {
        // check if the window has already been refreshed
        const hasRefreshed = JSON.parse(
            window.sessionStorage.getItem("retry-lazy-refreshed") || "false"
        );
        // try to import the component
        componentImport()
            .then((component) => {
                window.sessionStorage.setItem("retry-lazy-refreshed", "false"); // success so reset the refresh
                resolve(component);
            })
            .catch((error) => {
                if (!hasRefreshed) {
                    // not been refreshed yet
                    window.sessionStorage.setItem("retry-lazy-refreshed", "true"); // we are now going to refresh
                    return window.location.reload(); // refresh the page
                }
                reject(error); // Default error behaviour as already tried refresh
            });
    });
};


//Fow WebView Longitude/Latitude
// function getLocationConstant() {
//     if (navigator.geolocation) {

//         navigator.geolocation.getCurrentPosition(onGeoSuccess, onGeoError);
//     }
// }

// function onGeoSuccess(event) {

//     console.log("Webview Pushing Long/Lat=" + event.coords.latitude + ", " + event.coords.longitude);
//     var latlongFire = new CustomEvent("LongLatRec", {
//         detail: { lat: event.coords.latitude, long: event.coords.longitude },
//     });
//     window.dispatchEvent(latlongFire);
// }

// function onGeoError(event) {}

// setTimeout(getLocationConstant, 20000);
// setInterval(getLocationConstant, 20000);



function getOSName()
{
    var OSName="Unknown OS";
    if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
    if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
    if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";
    if (navigator.appVersion.indexOf("Android")!=-1) OSName="Android";
    return OSName;
}
function PushUserIdAndLocToAndroidApp(userId,loc)
{
  if (typeof app !== "undefined" && app !== null) {
    console.log("getUserIdAndLoc Pushed From Web: "+userId+"===="+loc);
    app.getUserIdAndLoc(userId,loc);
  }
}